export enum NameDisplayOrder {
  FIRST_LAST = "first_last",
  LAST_FIRST = "last_first",
  FIRST_ONLY = "first_only",
}
